"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_core_1 = require("@statsig/client-core");
class EvaluationStore {
    constructor() {
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
    }
    getValues() {
        return this._rawValues
            ? (0, client_core_1.typedJsonParse)(this._rawValues, 'has_updates', 'Failed to parse EvaluationStoreValues')
            : null;
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
    }
    finalize() {
        if (this._values) {
            return;
        }
        this._source = 'NoValues';
    }
    setValuesFromDataAdapter(result) {
        if (!result) {
            return;
        }
        const values = (0, client_core_1.typedJsonParse)(result.data, 'has_updates', 'Failed to parse EvaluationResponse');
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) {
            return;
        }
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._source = result.source;
        this._values = values;
    }
    getGate(name) {
        var _a, _b;
        const evaluation = (_b = (_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates[name]) !== null && _b !== void 0 ? _b : null;
        return this._makeDetailedEvaluation(evaluation);
    }
    getConfig(name) {
        var _a, _b;
        const evaluation = (_b = (_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs[name]) !== null && _b !== void 0 ? _b : null;
        return this._makeDetailedEvaluation(evaluation);
    }
    getLayer(name) {
        var _a, _b;
        const evaluation = (_b = (_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs[name]) !== null && _b !== void 0 ? _b : null;
        return this._makeDetailedEvaluation(evaluation);
    }
    _makeDetailedEvaluation(evaluation) {
        return {
            evaluation,
            details: this._getDetails(evaluation == null),
        };
    }
    _getDetails(isUnrecognized) {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') {
            return { reason: this._source };
        }
        const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
        const reason = `${this._source}:${subreason}`;
        return {
            reason,
            lcut: this._lcut,
            receivedAt: this._receivedAt,
        };
    }
}
exports.default = EvaluationStore;
